import swiper from "swiper/bundle";

export function sliderSettings() {
    // TOP メイン画像
    const topMainSlider = new swiper('.top_main-slider', {
        loop: true,
        effect: 'fade',
        autoplay: {
            delay: 3000,
        },
        speed: 800,
    })

    // TOP オススメ
    const topRecommend = new swiper('.list-slider', {
        loop: true,
        speed: 800,
        pagination: {
            el: '.swiper-pagination',
            clickable: 'true',
        },
        navigation: {
            nextEl: '.swiper-button-next',
            prevEl: '.swiper-button-prev',
        },
        breakpoints: {
            769: {
                slidesPerView:3,
                loop: false,
                followFinger: false
            }
        }
    })

    // 賃貸物件詳細 メイン画像サムネイル
    const singleMainSliderThumb = new swiper('.single-slider-thumb', {
        loop: true,
        speed: 500,
        slidesPerView: '1',
        effect: 'fade',
    })

    // 賃貸物件詳細 メイン画像
    const singleMainSlider = new swiper('.single-slider', {
        loop: true,
        speed: 500,
        pagination: {
            el: '.swiper-pagination',
            clickable: 'true',
        },
        navigation: {
            nextEl: '.swiper-button-next',
            prevEl: '.swiper-button-prev',
        },
        breakpoints: {
            769: {
                slidesPerView:5,
                centeredSlides: true,
                allowTouchMove: true,
                slideToClickedSlide: true,
            },
        },
        thumbs: {
            swiper: singleMainSliderThumb
        }
    })

    // 賃貸物件詳細 パノラマ画像
    if ( window.matchMedia('(max-width:798px)').matches ) {
        const panoramaSlider = new swiper('.panorama-slider', {
            loop: false,
            speed: 800,
            allowTouchMove: false,
            pagination: {
                el: '.swiper-pagination',
                clickable: true,
            },
            navigation: {
                nextEl: '.swiper-button-next',
                prevEl: '.swiper-button-prev',
            },
        })

        panoramaSlider.constructor;
    }

    // 会社概要 メイン画像
    const companySlider = new swiper('.recruit-slider', {
        loop: true,
        speed: 500,
        pagination: {
            el: '.swiper-pagination',
            clickable: 'true',
        },
        navigation: {
            nextEl: '.swiper-button-next',
            prevEl: '.swiper-button-prev',
        },
        breakpoints: {
            769: {
                slidesPerView:3,
                centeredSlides: true,
                allowTouchMove: true,
                slideToClickedSlide: true,
            },
        },
    })

    singleMainSlider.constructor;
    topMainSlider.constructor;
    singleMainSliderThumb.constructor;
    topRecommend.constructor;
    companySlider.constructor;
}


